import { MapMarkerIcon } from "interfaces/components/Map/MapMarkerIcon";
import { useEffect, useState } from "react";
import ActiveVehicle from "assets/map/vehicle/activevehicle.png";
import InActiveVehicle from "assets/map/vehicle/inactivevehicle.png";
import OfflineVehicle from "assets/map/vehicle/offlinevehicle.png";
import WarningVehicle from "assets/map/vehicle/warningvehicle.png";
import HwrcSite from "assets/map/site/hwrcsite.png";
import DisposalSite from "assets/map/site/disposalsite.png";

import "./googlemap.scss";
import { MapMarkerProps } from "interfaces/components/Map/MapMarkerProps";

const MapMarker = ({
  id,
  title,
  icon,
  onClick,
  details
}: MapMarkerProps) => {
  const [showInfo, setShowInfo] = useState(false);
  useEffect(() => {}, [showInfo]);

  const handlePinClick = (selectedKey: number) => {
    if (onClick !== undefined) onClick(selectedKey, details);
    setShowInfo(!showInfo);
  };

  const getPinIcon = (pinIcon: MapMarkerIcon) => {
    let img;

    const buttonClass = onClick !== undefined
      ? "pin-icon-button"
      : "pin-icon-button pin-icon-button-no-cursor";

    switch (pinIcon) {
      case MapMarkerIcon.HwrcSite: {
        img = (
          <button
            key={id}
            title={title}
            className={buttonClass}
            type="button"
            onClick={
              onClick !== undefined ? () => handlePinClick(id) : undefined
            }
            tabIndex={-1}
          >
            <img src={HwrcSite} className="pin-icon" alt="Hwrc Site " />
          </button>
        );
        break;
      }
      case MapMarkerIcon.DisposalSite: {
        img = (
          <button
            key={id}
            title={title}
            className={buttonClass}
            type="button"
            onClick={
              onClick !== undefined ? () => handlePinClick(id) : undefined
            }
            tabIndex={-1}
          >
            <img src={DisposalSite} className="pin-icon" alt="Disposal Site" />
          </button>
        );
        break;
      }
      case MapMarkerIcon.Active: {
        img = (
          <button
            key={id}
            title={title}
            className={buttonClass}
            type="button"
            onClick={
              onClick !== undefined ? () => handlePinClick(id) : undefined
            }
            tabIndex={-1}
          >
            <img
              src={ActiveVehicle}
              className="pin-icon"
              alt="Active Vehicle"
            />
          </button>
        );
        break;
      }
      case MapMarkerIcon.Inactive: {
        img = (
          <button
            key={id}
            title={title}
            className={buttonClass}
            type="button"
            onClick={
              onClick !== undefined ? () => handlePinClick(id) : undefined
            }
            tabIndex={-1}
          >
            <img
              src={InActiveVehicle}
              className="pin-icon"
              alt="Inactive Vehicle"
            />
          </button>
        );
        break;
      }
      case MapMarkerIcon.Offline: {
        img = (
          <button
            key={id}
            title={title}
            className={buttonClass}
            type="button"
            onClick={
              onClick !== undefined ? () => handlePinClick(id) : undefined
            }
            tabIndex={-1}
          >
            <img
              src={OfflineVehicle}
              className="pin-icon"
              alt="Offline Vehicle"
            />
          </button>
        );
        break;
      }
      case MapMarkerIcon.Warning: {
        img = (
          <button
            key={id}
            title={title}
            className={buttonClass}
            type="button"
            onClick={
              onClick !== undefined ? () => handlePinClick(id) : undefined
            }
            tabIndex={-1}
          >
            <img
              src={WarningVehicle}
              className="pin-icon"
              alt="Warning Vehicle"
            />
          </button>
        );
        break;
      }
      default: {
        break;
      }
    }
    return img;
  };

  const pinClass: string = "pin";

  return <div className={pinClass}>{getPinIcon(icon)}</div>;
};

export default MapMarker;
